export default __webpack_public_path__ + "static/media/leads-gray.dcae61d3.svg";